import type { HTMLAttributes, ReactNode } from "react";
import { cx } from "./cx";

export function Panel({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("panel", className)} {...rest} />;
}

export interface PanelHeadProps {
  title: ReactNode;
  /** Mono sub-line under the title (the POC's `.sub`). */
  sub?: ReactNode;
  /** Right-aligned actions (buttons, pills). */
  actions?: ReactNode;
}

/** Matches the POC shape: `.panel-head > div > h3 + span.sub` with trailing actions. */
export function PanelHead({ title, sub, actions }: PanelHeadProps) {
  return (
    <div className="panel-head">
      <div>
        <h3>{title}</h3>
        {sub != null && <span className="sub">{sub}</span>}
      </div>
      {actions != null && <div className="actions">{actions}</div>}
    </div>
  );
}

export function PanelBody({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cx("panel-body", className)} {...rest} />;
}
